import { combineReducers } from 'redux';
import SurveyReducer from './SurveyReducer';
import UserReducer from './UserReducer';
import FeedReducer from './FeedReducer';
import MatchReducer from './MatchReducer';

const reducer = combineReducers({
  survey: SurveyReducer,
  user: UserReducer,
  feed: FeedReducer,
  matches: MatchReducer,
});

export default reducer;
